import { render, staticRenderFns } from "./studentRecordItem.vue?vue&type=template&id=12ba7159&scoped=true&"
import script from "./studentRecordItem.vue?vue&type=script&lang=js&"
export * from "./studentRecordItem.vue?vue&type=script&lang=js&"
import style0 from "./studentRecordItem.vue?vue&type=style&index=0&id=12ba7159&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ba7159",
  null
  
)

export default component.exports